import { useRef, useState } from 'react';
import { Upload } from 'antd';
import { useApp } from 'contexts/app';
import ImageService from 'services/image';
import { getPreviewSource } from '../MultiImagePicker/useComponent';

const useComponent = ({ value, onChange, acceptedFormats, maxFileSize }) => {
    const { notification } = useApp();
    const [loading, setLoading] = useState(false);
    const [sheetOpen, setSheetOpen] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [libraryOpen, setLibraryOpen] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const uploadRef = useRef(null);

    const acceptValue = (acceptedFormats || []).join(',');
    const previewSrc = value ? getPreviewSource(value) : '';
    const hasValue = !!value;

    const handleUpload = async (file) => {
        const validType = (acceptedFormats || []).some((f) => {
            if (f.endsWith('/*')) return file.type.startsWith(f.replace('/*', '/'));
            if (f.startsWith('.')) return file.name.toLowerCase().endsWith(f);
            return file.type === f;
        });

        if (!validType) {
            notification.error('Định dạng file không được hỗ trợ');
            return Upload.LIST_IGNORE;
        }

        if (file.size > maxFileSize) {
            notification.error('File quá lớn');
            return Upload.LIST_IGNORE;
        }

        setLoading(true);
        try {
            const svc = new ImageService();
            const fd = new FormData();
            fd.append('file', file);
            const result = await svc.upload(fd);
            onChange(result);
        } catch {
            notification.error('Tải ảnh thất bại. Vui lòng thử lại');
        } finally {
            setLoading(false);
        }

        return Upload.LIST_IGNORE;
    };

    const triggerUpload = () => {
        setSheetOpen(false);
        setTimeout(() => uploadRef.current?.querySelector('input[type="file"]')?.click(), 300);
    };

    const handlePreview = () => {
        setSheetOpen(false);
        setPreviewImage(previewSrc);
        setPreviewOpen(true);
    };

    const handleRemove = () => {
        setSheetOpen(false);
        setConfirmDelete(false);
        onChange(null);
    };

    const handleLibrarySelect = (images) => {
        if (images?.length >= 1) onChange(images[0]);
        setLibraryOpen(false);
    };

    const openLibrary = () => {
        setSheetOpen(false);
        setTimeout(() => setLibraryOpen(true), 300);
    };

    return {
        loading,
        sheetOpen,
        setSheetOpen,
        previewOpen,
        setPreviewOpen,
        previewImage,
        setPreviewImage,
        libraryOpen,
        setLibraryOpen,
        confirmDelete,
        setConfirmDelete,
        uploadRef,
        acceptValue,
        previewSrc,
        hasValue,
        handleUpload,
        triggerUpload,
        handlePreview,
        handleRemove,
        handleLibrarySelect,
        openLibrary,
    };
};

export default useComponent;
